import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../../styles/constants';

export const useStyles = makeStyles(theme => ({
	content: {
		[theme.breakpoints.only('lg')]: {
			maxWidth: 928
		},
		gap: theme.spacing(3),
		padding: `${theme.spacing(6)}px ${theme.spacing(1.5)}px`
	},
	cardText: {
		'& .MuiTypography-subtitle1': {
			lineHeight: 1.5
		}
	},
	card: {
		display: 'flex',
		position: 'relative',
		flexWrap: 'wrap',
		flexDirection: 'column',
		height: '100%',
		overflow: 'hidden',
		border: `1px solid ${COLORS.BORDER}`,
		backgroundColor: 'rgb(252, 252, 253)',
		borderRadius: '12px',
		padding: theme.spacing(2),
		'& .MuiCardActions-root': {
			marginTop: 'auto',
			padding: 0,
			width: '100%'
		},
		'& .MuiCardContent-root': {
			padding: 0,
			paddingBottom: theme.spacing(2)
		},
		maxWidth: 440,
		minWidth: 150
	},
	button: {
		backgroundColor: '#FF7920 !important',
		color: '#1D3546 !important',
		borderRadius: '50px',
		fontWeight: '600',
		textTransform: 'none',
		'&:focus': {
			boxShadow: '0 0 4px'
		},
		'&:focus-visible': {
			boxShadow: '0 0 4px'
		},
		'& .MuiButton-label': {
			gap: theme.spacing(1.25),
			fontSize: '1em'
		}
	}
}));
